
import { defineNuxtPlugin } from '#app/nuxt'
export default defineNuxtPlugin({
  name: 'nuxt:vue-app-config',
  enforce: 'pre',
  setup (nuxtApp) {
        nuxtApp.vueApp.config["productionTip"] = false
    nuxtApp.vueApp.config["devtools"] = false
  }
})